'use strict'

import { formatTime, formatTrueFalse } from '../../../../components/helpers.js'
import { axiosGet } from '../../../../axios/axios.js'
import StockControl from './StockControl.vue'
import StockControlMobile from './StockControlMobile.vue'
import StockControlRecord from './StockControlRecord.vue'

function formatAmount (value) {
  if (value) {
    return Math.floor(value * 1000) / 1000
  } else {
    return value
  }
}

export function getStockControlToolRecordColumns (mode) {
  let columns = [{
    name: 'ordinalNumber',
    label: '№ п/п (по порядку)',
    labelTable: '№</br>п/п',
    defaultWidth: 40,
    sortable: false
  },
  {
    name: 'controlledBySelectedDepartment',
    label: 'Контроль данным отделом',
    labelTable: 'Контроль</br>данным</br>отделом',
    defaultWidth: 70,
    align: 'center',
    alwaysActive: true,
    sortable: true
  },
  {
    name: 'toolName',
    label: 'Наименование номенклатурной позиции',
    labelTable: 'Наименование</br>номенклатурной</br>позиции',
    defaultWidth: 300,
    alwaysActive: true,
    sortable: true
  },
  {
    _mode: 'edit',
    name: 'controllingDepartments',
    label: 'Контролирующие отделы на данном складе',
    labelTable: 'Контролирующие отделы</br>на данном складе',
    defaultWidth: 280,
    sortable: false,
    columnFormat: 'objects',
    columnObjectType: 'department'
  },
  {
    name: 'isParty',
    label: 'Партии',
    defaultWidth: 80,
    sortable: true,
    alwaysActive: true,
    format: formatTrueFalse
  },
  {
    name: 'partiesCount',
    label: 'Кол-во партий',
    defaultWidth: 80,
    sortable: true
  },
  {
    name: 'amount',
    label: 'Остаток на данном складе (1С)',
    labelTable: 'Остаток</br>на данном</br>складе (1С)',
    defaultWidth: 80,
    sortable: true,
    format: formatAmount
  },
  {
    _mode: 'edit',
    name: 'statStocks',
    label: 'Остатки на стационарных складах',
    labelTable: 'Остатки на</br>стационарных</br>складах',
    defaultWidth: 170,
    sortable: false
  },
  {
    _mode: 'edit',
    name: 'filteredStocksAmount',
    label: 'Остаток на складах (выбранных)',
    labelTable: 'Остаток</br>на складах</br>(выбранных)',
    defaultWidth: 80,
    sortable: true,
    format: formatAmount
  },
  {
    name: 'unit',
    label: 'Единица измерения',
    labelTable: 'Единица</br>измерения',
    defaultWidth: 70,
    sortable: false
  },
  {
    _mode: 'edit',
    name: 'toolKey',
    label: 'ID номенклатурной позиции в 1С',
    labelTable: 'ID номенклатурной</br>позиции в 1С',
    defaultWidth: 140,
    sortable: false
  },
  {
    _mode: 'edit',
    name: 'nomType',
    label: 'Тип номенклатуры',
    labelTable: 'Тип</br>номен-</br>клатуры',
    defaultWidth: 80,
    sortable: true
  },
  {
    _mode: 'edit',
    name: 'nomVid',
    label: 'Вид номенклатуры',
    labelTable: 'Вид</br>номенклатуры',
    defaultWidth: 130,
    sortable: true
  },
  {
    _mode: 'edit',
    name: 'nomAffilation',
    label: 'Принадлежность номенклатуры',
    labelTable: 'Принадлежность</br>номенклатуры',
    defaultWidth: 110,
    sortable: true
  },
  {
    _mode: 'view',
    name: 'zeroAmountReason',
    label: 'Причина нулевого остатка',
    labelTable: 'Причина</br>нулевого</br>остатка',
    format: val => val && val.name || null,
    defaultWidth: 110,
    sortable: false
  },
  {
    _mode: 'view',
    name: 'zeroAmountTime',
    label: 'Дата/время регистрации нулевого остатка',
    labelTable: 'Дата/время регистрации</br>нулевого остатка',
    format: formatTime,
    defaultWidth: 90,
    sortable: false
  },
  {
    _mode: 'view',
    name: 'zeroAmountOutTime',
    label: 'Дата/время восстановления ненулевого остатка',
    labelTable: 'Дата/время восстановления</br>ненулевого остатка',
    format: formatTime,
    defaultWidth: 90,
    sortable: false
  },
  {
    _mode: 'view',
    name: 'controlTime',
    label: 'Дата/время последний проверки',
    labelTable: 'Дата/время</br>последний проверки',
    format: formatTime,
    defaultWidth: 90,
    sortable: false
  },
  {
    _mode: 'view',
    name: 'controlResult',
    label: 'Результат проверки',
    labelTable: 'Результат</br>проверки',
    format: val => val && val.name || null,
    defaultWidth: 80,
    sortable: false
  }]

  const additionalColumns = getStockControlRecordColumns()
  for (const column of additionalColumns) {
    column._mode = 'view'
  }

  columns.push(...additionalColumns)

  columns.push({
    name: 'stock',
    label: 'Склад',
    labelTable: 'Склад',
    defaultWidth: 70,
    sortable: true,
    format: value => value && value.name || ''
  },
  {
    name: 'garageNumber',
    label: 'Бортовой номер ТС',
    labelTable: 'Бортовой</br>номер</br>ТС',
    defaultWidth: 70,
    sortable: true
  })

  if (mode) {
    columns = columns.filter(column => column._mode == null || column._mode === mode)
  }

  return columns
}

export function getStockControlJournalRecordColumns () {
  const columns = [{
    name: 'controlTime',
    label: 'Дата/время события',
    labelTable: 'Дата/время</br>события',
    format: formatTime,
    defaultWidth: 80,
    sortable: false
  },
  {
    name: 'recordType',
    label: 'Тип события', // Тип
    field: record => {
      const complexTypeName = {
        baseName: null,
        eventName: null
      }
      if (record.type === 'stockControlPresenceCheckJournalRecord') {
        if (record.eventType === 'presenceCheckSkippedOnVehicleGive') {
          complexTypeName.baseName = 'Выдача ТС без проверки наличия позиций' // Выдача ТС без проверки фактического наличия позиций на складе
        } else if (record.eventType === 'presenceCheckVehicleReturnAfterSkippedOnVehicleGive') {
          complexTypeName.baseName = 'Сдача ТС, выданного без проверки наличия позиций' // Сдача ТС, выданного без проверки фактического наличия позиций на складе
        } else {
          complexTypeName.baseName = 'Проверка фактического наличия позиций' // Проверка фактического наличия позиций на складе
        }

        if (record.stage == 'vehicleGive') {
          complexTypeName.eventName = 'Выдача ТС'
        } else if (record.stage == 'vehicleReturn') {
          complexTypeName.eventName = 'Сдача ТС'
        } else {
          complexTypeName.eventName = 'Дополнительная проверка' // 'Повторная проверка'
        }

        if (record.skipped) {
          complexTypeName.eventName += ' без проверки'
        }
      } else if (record.type === 'stockControlSettingsJournalRecord') { // Настройка контролируемых позиций
        if (record.settingOperation === 'add') {
          complexTypeName.baseName = 'Добавление контролируемой позиции'
        } else {
          complexTypeName.baseName = 'Удаление контролируемой позиции'
        }
      } else if (record.type === 'stockControlZeroAmountJournalRecord') {
        if (record.zeroAmountOperation === 'zeroAmountIn') {
          complexTypeName.baseName = 'Обнуление остатка' // контролируемой позиции
          if (record.reason) {
            complexTypeName.eventName = record.reason
          }
        } else {
          complexTypeName.baseName = 'Восстановление ненулевого остатка' // контролируемой позиции
        }
      }
      return complexTypeName
    },
    defaultWidth: 140,
    sortable: false
  },
  {
    name: 'tools',
    label: 'Номенклатурная позиция',
    columnFormat: 'objects',
    columnObjectType: 'tool',
    defaultWidth: 300,
    sortable: false
  }]

  const additionalColumns = getStockControlRecordColumns()
  columns.push(...additionalColumns)

  return columns
}

export function getStockControlRecordColumns () {
  const columns = [{
    name: 'controlEmployee',
    // label: 'Сотрудник, создавший запись',
    // labelTable: 'Сотрудник',
    label: 'Источник события', // Сотрудник
    defaultWidth: 120,
    sortable: false,
    field: record => {
      if (record.amountChangeSourceType === 'onec') {
        return '1С'
      } else {
        const employee = record.controlEmployee
        if (employee && employee.id) {
          return employee
        } else if (record.sourceName) {
          return record.sourceName
        }
        return employee && employee.name || ''
      }
    },
    columnFormat: 'object',
    columnObjectType: 'employee'
  },
  {
    name: 'controlEmployeeDepartment',
    // label: 'Отдел сотрудника, выполнившего проверку',
    // labelTable: 'Отдел',
    label: 'Отдел',
    defaultWidth: 220,
    sortable: false,
    columnFormat: 'object',
    columnObjectType: 'department'
  },
  {
    name: 'controlEmployeePosition',
    label: 'Должность сотрудника',
    // label: 'Должность сотрудника, выполнившего проверку',
    // labelTable: 'Должность',
    defaultWidth: 100,
    sortable: false,
    columnFormat: 'object',
    columnObjectType: 'employeePosition'
  },
  {
    name: 'controlBrigade',
    // label: 'Бригада, выполнившая проверку',
    // labelTable: 'Бригада',
    label: 'Бригада',
    defaultWidth: 140,
    sortable: false
  },
  {
    name: 'controlWorkShift',
    // label: 'Смена бригады, выполнившей проверку',
    // labelTable: 'Смена бригады',
    label: 'Смена бригады',
    field: 'controlWorkShiftDate',
    format: val => val && val.name || null,
    defaultWidth: 90,
    sortable: false
  }]

  return columns
}

// export function showStockControlDialog (config) {
//   const target = config.target
//   const dialog = target.$d.dialog(target).show({
//     maximizedOnNarrow: true,
//     persistent: true,
//     contentWidth: 800,
//     headerLabel: 'Контроль номенклатурных позиций',
//     class: 'stock-control__dialog',
//     contentComponent: StockControl,
//     contentProps: {
//       stockId: config.stockId,
//       formId: config.formId,
//       defaultDepartmentId: config.defaultDepartmentId,
//       stockControlRecordId: config.stockControlRecordId,
//       class: 'q-pt-xs q-px-xs'
//     },
//     componentHandlers: {
//       performed: () => {
//         dialog.hide()
//       },
//       close: () => {
//         dialog.hide()
//       }
//     }
//   })
// }

export function openStockControlRecordView (config) {
  // config.target.$router.push({ name: 'stockControlRecord', params: { id: config.stockControlRecordId, type: config.stockControlRecordType } })
  const url = '/stockControlRecord/' + config.stockControlRecordType + '/' + config.stockControlRecordId
  window.open(url, '_blank')
}

export function showStockControlDispatcherRecordDialog (config) {
  if (config.stockControlRecordType === 'stockControlPresenceCheckJournalRecord') {
    showStockControlDialog(config)
  } else {
    showStockControlRecordDialog(config)
  }
}

export function showStockControlDialog (config) {
  let promise
  if (config.stockControlRecordId) {
    promise = loadStockControl({
      stockControlRecordId: config.stockControlRecordId,
      target: config.target
    })
  } else {
    promise = loadStockControl({
      stockId: config.stockId,
      depId: config.depId,
      target: config.target
    })
  }
  promise.then(stockControl => {
    openStockControlDialog({
      stockControl,
      formId: config.formId || null,
      readonly: !!config.readonly,
      onRecordSaved: config.onRecordSaved || null,
      mobile: !!config.mobile,
      target: config.target
    })
  })
}

export function openStockControlDialog (dialogConfig) {
  const stockControl = dialogConfig.stockControl // !!!
  const target = dialogConfig.target
  const formId = dialogConfig.formId || null // 'stockCard'
  const readonly = !!dialogConfig.readonly // false
  const onRecordSaved = dialogConfig.onRecordSaved || null // null
  const mobile = !!dialogConfig.mobile // false

  const stockControlProps = {
    stockControl: stockControl,
    stockId: stockControl.stock.id,
    formId: formId,
    defaultDepartmentId: stockControl.department.id,
    stockControlRecordId: stockControl.stockControlRecord && stockControl.stockControlRecord.id || null,
    readonly: readonly,
    class: 'q-pt-xs q-px-xs'
  }

  const dialog = target.$d.dialog(target).show({
    maximizedOnNarrow: true,
    persistent: true,
    contentWidth: 800,
    headerLabel: stockControl.stockControlRecord && stockControl.stockControlRecord.name || 'Контроль номенклатурных позиций',
    class: mobile ? '' : 'stock-control__dialog',
    contentComponent: mobile ? StockControlMobile : StockControl,
    contentProps: stockControlProps,
    componentHandlers: {
      'record-saved': (stockControlRecordId) => {
        dialog.hide()

        if (onRecordSaved) {
          onRecordSaved(stockControlRecordId)
        }
      },
      'reload-record': function (config) {
        loadStockControl(config).then(stockControlNew => {
          stockControlProps.stockControl = stockControlNew
          stockControlProps.stockId = stockControlNew.stock.id
          stockControlProps.defaultDepartmentId = stockControlNew.department.id
          stockControlProps.stockControlRecordId = stockControlNew.stockControlRecord && stockControlNew.stockControlRecord.id || null
        })
      },
      close: () => {
        dialog.hide()
      }
    }
  })
}

export function loadStockControl (config) {
  const urlParams = new URLSearchParams()
  if (config.stockControlRecordId) {
    urlParams.set('stockControlRecordId', config.stockControlRecordId)
  } else {
    urlParams.set('stockId', config.stockId)
    if (config.depId) {
      urlParams.set('depId', config.depId)
    }
  }

  config.target.loading = true
  return axiosGet({
    url: 'service/delta/stock/control/record/getStockControl?' + urlParams.toString(),
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: (response) => {
      config.target.$q.notify({
        type: 'negative',
        message: response.message || 'Ошибка получения записи журнала контроля наличия',
        progress: true,
        timeout: 10000
      })

      return Promise.reject(response.message)
    }
  }).finally(() => {
    config.target.loading = false
  })
}

export function loadStockControls (config) {
  const urlParams = new URLSearchParams()
  urlParams.set('vehicleIssuanceRecordId', config.vehicleIssuanceRecordId)
  if (config.stage) {
    urlParams.set('stage', config.stage)
  }

  return axiosGet({
    url: 'service/delta/stock/control/record/getVehicleIssuanceStockControls?' + urlParams.toString(),
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: (response) => {
      if (config.target) {
        config.target.$q.notify({
          type: 'negative',
          message: response.message || 'Ошибка получения складов для контроля наличия номенклатуры',
          progress: true,
          timeout: 10000
        })
      }

      return Promise.reject(response.message)
    }
  })
}

export function showStockControlRecordDialog (config) {
  loadStockControlRecord({
    stockControlRecordId: config.stockControlRecordId,
    stockControlRecordType: config.stockControlRecordType,
    target: config.target
  }).then(stockControlRecord => {
    openStockControlRecordDialog({
      record: stockControlRecord,
      formId: config.formId || null,
      readonly: !!config.readonly,
      onRecordSaved: config.onRecordSaved || null,
      mobile: !!config.mobile,
      target: config.target
    })
  })
}

export function loadStockControlRecord (config) {
  const urlParams = new URLSearchParams()
  urlParams.set('stockControlRecordId', config.stockControlRecordId)
  urlParams.set('stockControlRecordType', config.stockControlRecordType)

  config.target.loading = true
  return axiosGet({
    url: 'service/delta/stock/control/record/get?' + urlParams.toString(),
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: (response) => {
      config.target.$q.notify({
        type: 'negative',
        message: response.message || 'Ошибка получения записи журнала контроля наличия',
        progress: true,
        timeout: 10000
      })

      return Promise.reject(response.message)
    }
  }).finally(() => {
    config.target.loading = false
  })
}

export function openStockControlRecordDialog (dialogConfig) {
  // const stockControl = dialogConfig.stockControl // !!!
  const record = dialogConfig.record // !!!
  const target = dialogConfig.target
  const formId = dialogConfig.formId || null // 'stockCard'
  const readonly = !!dialogConfig.readonly // false
  const onRecordSaved = dialogConfig.onRecordSaved || null // null
  const mobile = !!dialogConfig.mobile // false

  const stockControlProps = {
    record: record,
    // stockId: stockControl.stock.id,
    formId: formId,
    // defaultDepartmentId: stockControl.department.id,
    // stockControlRecordId: stockControl.stockControlRecord && stockControl.stockControlRecord.id || null,
    readonly: readonly,
    class: 'q-pt-xs q-px-xs'
  }

  const dialog = target.$d.dialog(target).show({
    maximizedOnNarrow: true,
    persistent: true,
    contentWidth: 800,
    headerLabel: record && record.name || 'Запись журнала контроля номенклатурных позиций',
    class: mobile ? '' : 'stock-control__dialog',
    // contentComponent: mobile ? StockControlMobile : StockControl,
    contentComponent: StockControlRecord,
    contentProps: stockControlProps,
    componentHandlers: {
      'record-saved': (stockControlRecordId) => {
        dialog.hide()

        if (onRecordSaved) {
          onRecordSaved(stockControlRecordId)
        }
      },
      'reload-record': function (config) {
        // loadStockControl(config).then(stockControlNew => {
        loadStockControlRecord(config).then(stockControlNew => {
          stockControlProps.stockControl = stockControlNew
          stockControlProps.stockId = stockControlNew.stock.id
          stockControlProps.defaultDepartmentId = stockControlNew.department.id
          stockControlProps.stockControlRecordId = stockControlNew.stockControlRecord && stockControlNew.stockControlRecord.id || null
        })
      },
      close: () => {
        dialog.hide()
      }
    }
  })
}

export const SELECTED_DEPARTMENT_ID_PROPERTY = 'stockConfiguration.selectedDepartmentId'

export function getStoredSelectedDepartmentId (user) {
  const userDepartmentsIds = user.employee && user.employee.allDepartmentIds || []

  const selectedDepartmentIdValue = localStorage.getItem(SELECTED_DEPARTMENT_ID_PROPERTY)
  if (selectedDepartmentIdValue && !isNaN(selectedDepartmentIdValue)) {
    const selectedDepartmentId = Number(selectedDepartmentIdValue)

    const hasEditAccess = user.hasOperation('stockAccessoryControl')
    const hasAllDepartmentsEditAccess = user.hasOperation('stockAccessoryControl') && user.hasRole('admin')
    if (hasAllDepartmentsEditAccess || hasEditAccess && userDepartmentsIds.includes(selectedDepartmentId)) {
      return selectedDepartmentId
    }
  }
  return null
}

export function setStoredSelectedDepartmentId (departmentId) {
  if (departmentId != null) {
    localStorage.setItem(SELECTED_DEPARTMENT_ID_PROPERTY, departmentId)
  } else {
    localStorage.removeItem(SELECTED_DEPARTMENT_ID_PROPERTY)
  }
}
